/* global Excel */

import { macroImplementations } from "@/macros";
import { MacroId } from "@/types/lighthouse";

export async function runMacro(macroId: MacroId) {
  await Excel.run(async (context) => {
    const macroFn = macroImplementations[macroId];
    if (macroFn) {
      await macroFn(context);
    } else {
      console.error("No implementation for macro", macroId);
    }
  });
}
